import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-confirm-offers-edit-dialog',
  templateUrl: 'confirm-offers-edit-dialog.component.html',
  styleUrls: ['./confirm-offers-edit-dialog.component.scss']
})
export class ConfirmOffersEditDialogComponent {
  public offersToUpdate: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { offers: number }) {
    this.offersToUpdate = data.offers;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/offer-list/mass-offers-edit/confirm-offers-edit-dialog/confirm-offers-edit-dialog.component.ts